import { render, staticRenderFns } from "./SettlingComponent.vue?vue&type=template&id=28e4173e&"
import script from "./SettlingComponent.vue?vue&type=script&lang=ts&"
export * from "./SettlingComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SettlingComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports